const PARAGRAPH_USER_LATEST = (uuid: string, language: string, userName: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
  ... on UserListing {
      id
      heading
      icon
      type
      uuid
      listing(username: "${userName}") {
        nid
        bodyListing
        categories {
          alias
          color
          name
          weight
        }
        featuredImage {
          alt
          horizontalCardImage
        }
        memberOnly
        pathAlias
        publishedOn
        statusCode
        summaryListing
        title
        ... on Article {
          authors {
            title
            pathAlias
          }
          ctaButtons {
            color
            title
            url
          }
          readDuration
        }
        ... on News {
          ctaButtons {
            color
            title
            url
          }
        }
      }
    }
  }
`;

export default PARAGRAPH_USER_LATEST;
